import { useMemo } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Modal } from "../../../components/Modal";
import { spacing } from "@styling/sizing";
import { fontSizes } from "@styling/fonts";
import colors from "@styling/colors";

const SHOPIFY_GUIDE_STEP_KEYS = [
  "shopifyProvision.guide.step1",
  "shopifyProvision.guide.step2",
  "shopifyProvision.guide.step3",
  "shopifyProvision.guide.step4",
  "shopifyProvision.guide.step5",
  "shopifyProvision.guide.step6",
  "shopifyProvision.guide.step7",
  "shopifyProvision.guide.step8",
] as const;

const GuideIntro = styled.p`
  margin: 0 0 ${spacing.x2}px;
  color: ${colors.textMuted};
  font-size: ${fontSizes.regular}px;
  line-height: 1.5;
`;

const GuideList = styled.ol`
  margin: 0;
  padding-left: ${spacing.x4}px;
  display: flex;
  flex-direction: column;
  gap: ${spacing.x2}px;
  color: ${colors.text};
  font-size: ${fontSizes.regular}px;
  line-height: 1.5;
`;

interface ShopifyPartnerGuideModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ShopifyPartnerGuideModal = ({
  isOpen,
  onClose,
}: ShopifyPartnerGuideModalProps) => {
  const { t } = useTranslation();

  const guideSteps = useMemo(
    () =>
      SHOPIFY_GUIDE_STEP_KEYS.map((stepKey) =>
        t(stepKey, {
          redirectUrl: t("shopifyProvision.guide.redirectUrl"),
          scopes: t("shopifyProvision.guide.scopes"),
        }),
      ),
    [t],
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t("shopifyProvision.guide.title")}
      maxWidth={720}
    >
      <GuideIntro>{t("shopifyProvision.guide.intro")}</GuideIntro>
      <GuideList>
        {guideSteps.map((step) => (
          <li key={step}>{step}</li>
        ))}
      </GuideList>
    </Modal>
  );
};
